export enum Range {
  MINIMUM = 7,
  MAXIMUM = 19
}
